export default "__VITE_ASSET__CQKZmWDj__"